import { createFileRoute } from '@tanstack/react-router';
import PoliciesPage from '../../components/pages/policies';
import { requireAccess } from '../../auth/authUtils';

export const Route = createFileRoute('/policies/')({
  component: PoliciesPage,
  head: () => ({
    meta: [
      {
        title: 'Policy Navigator | Ingle Lewer',
      },
    ],
  }),
  beforeLoad: async ({ context }) => {
    requireAccess(context);
  },
});
